// extracted by mini-css-extract-plugin
module.exports = {"requiredMark":"required-mark-module__requiredMark--BlL7T"};